import React, { useEffect, useState } from 'react';
import { Radar } from 'react-chartjs-2';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';
import PropTypes from 'prop-types';

import InvitationServices from '../api/invitationServices';

import '../styles/Table.css';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const AssessmentAnswers = ({ invitationCode }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [assessment, setAssessment] = useState(null);
    const [answers, setAnswers] = useState({});
    const [invitation, setInvitation] = useState(null);
    const [email, setEmail] = useState('');
    const [mode, setMode] = useState('responding');
    const [name, setName] = useState('');
    const [totalQuestions, setTotalQuestions] = useState(0);

    useEffect(() => {
        const fetchInvitation = async () => {
            try {
                const invitationData = await InvitationServices.getInvitation(invitationCode);
                const total = invitationData.assessment.sections.reduce((sum, section) => sum + section.questions.length, 0);
                setTotalQuestions(total);
                invitationData.assessment.sections.sort((a, b) => a.order - b.order);
                invitationData.assessment.sections.forEach(section => {
                    section.questions.sort((a, b) => a.order - b.order);
                });
                setAssessment(invitationData.assessment);
                if (invitationData.results) {
                    setName(invitationData.name);
                    setEmail(invitationData.email);
                    setAnswers(invitationData.answers);
                    setMode('results');
                }
                setInvitation(invitationData);
            } catch (error) {
                console.error('Error fetching invitation:', error);
            }
        };

        fetchInvitation();
    }, [invitationCode]);

    const handleAnswerChange = (questionId, answer) => {
        setAnswers((prevAnswers) => ({
            ...prevAnswers,
            [questionId]: answer,
        }));
    };

    const handleRequestPdf = async () => {
//        const data = await InvitationServices.requestPdf(invitationCode);
//        console.log(data);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const invitationData = {
            id: invitationCode,
            email: email,
            name: name,
            answers: answers
        };
        const data = await InvitationServices.saveInvitationAnswers(invitationData);
        setInvitation(data);
        setMode('results');
    };

    const handleTabChange = (event) => {
        setActiveTab(parseInt(event.target.value, 10));
    };

    if (!assessment) {
        return <div>Loading...</div>;
    }

    if (mode === 'results') {
        const data = {
            labels: invitation.results.map(result => result.sectionName),
            datasets: [
                {
                    label: 'Nivel por tema',
                    data: invitation.results.map(result => result.score),
                    backgroundColor: 'rgba(34, 202, 236, 0.2)',
                    borderColor: 'rgba(34, 202, 236, 1)',
                    pointBackgroundColor: 'rgba(34, 202, 236, 1)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(34, 202, 236, 1)',
                },
            ],
        };

        const options = {
            scales: {
                r: {
                    angleLines: {
                        display: false
                    },
                    suggestedMin: 0,
                    suggestedMax: 5
                }
            }
        };

        return (
            <div className="results">
                <div className="results-data">
                    <img src="/frac7al_tr.png" width="100%" alt="Frac7al" />
                    <h3>!Hola { invitation.name }!</h3>
                    <p>Gracias por tus respuestas</p>
                    <p>Esta gráfica muestra el resultado</p>
                    <br/>
                    <div className="results-actions">
                        <button
                            onClick={() => setMode('responding')}
                            className="primary"
                        >
                            Revisar respuestas
                        </button>
                        <br/>
                        <button
                            onClick={() => handleRequestPdf()}
                            className="primary"
                        >
                            Enviar resultados por correo
                        </button>
                    </div>
                </div>
                <div className="results-chart">
                    <Radar data={data} options={options} />
                </div>
                <div className="results-actions-mobile">
                    <button
                        onClick={() => setMode('responding')}
                        className="primary"
                    >
                        Revisar respuestas
                    </button>
                    <br/>
                    <button
                        onClick={() => handleRequestPdf()}
                        className="primary"
                    >
                        Enviar resultados por correo
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="main-content assessment">
            <div className="invitation-header">
                <div className="invitation-logo">
                    <img src="/frac7al_tr.png" width="100%" alt="Frac7al" />
                </div>
                <div className="invitation-text">
                    <h3>{assessment.name}</h3>
                    <p>{assessment.invitationText}</p>
                </div>
            </div>
            <form onSubmit={handleSubmit}>
                <div className="tabs">
                    <button
                        key={`tab-0`}
                        type="button"
                        className={activeTab === 0 ? 'active' : ''}
                        onClick={() => setActiveTab(0)}
                    >
                        Tus datos
                    </button>
                    {assessment.sections.map((section, index) => (
                        <button
                            key={`tab-${index+1}`}
                            type="button"
                            className={activeTab === index+1 ? 'active' : ''}
                            onClick={() => setActiveTab(index+1)}
                        >
                            {section.name}
                        </button>
                    ))}
                </div>
                <div className="mobile-tabs">
                    <div className="select-label">Selecciona una sección:</div>
                    <select value={activeTab} onChange={handleTabChange}>
                        <option value={0}>Tus datos</option>
                        {assessment.sections.map((section, index) => (
                            <option key={`mobile-tab-${index+1}`} value={index+1}>
                                {section.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div key="0" style={{ display: activeTab === 0 ? 'block' : 'none' }}>
                    <div className="form-group">
                        <label>
                            Nombre:
                            <input
                                type="text"
                                name="name"
                                value={name || ''}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </label>
                    </div>
                    <br/>
                    <div className="form-group">
                        <label>
                            Email:
                            <input
                                type="email"
                                name="email"
                                value={email || ''}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </label>
                    </div>
                </div>
                {assessment.sections.map((section, index) => (
                    <div key={section.id} style={{ display: activeTab === index+1 ? 'block' : 'none' }}>
                        {section.questions.map((question) => {
                            const questionCriteria = assessment.criteria.find((c) => c.id === question.criteriaId);
                            return (
                                <div key={question.id}>
                                    <h4>{question.name}</h4>
                                    {questionCriteria.answers.map((option) => (
                                        <label key={`${question.id}-${option.score}`} className="radio-option">
                                            <input
                                                type="radio"
                                                name={`question-${question.id}`}
                                                value={option.score}
                                                checked={answers[question.id] === option.score}
                                                onChange={() => handleAnswerChange(question.id, option.score)}
                                            />
                                            {option.description}
                                        </label>
                                    ))}
                                </div>
                            );
                        })}
                    </div>
                ))}
                <br/>
                <div>
                    <p>Respuestas: {Object.keys(answers).length} de {totalQuestions}</p>
                </div>
                <div>
                    <button type="submit" className="primary">Enviar respuestas</button>
                </div>
            </form>
        </div>
    );
};

AssessmentAnswers.propTypes = {
    invitationCode: PropTypes.string.isRequired,
};

export default AssessmentAnswers;